// extracted by mini-css-extract-plugin
module.exports = {"content":"DeleteDomainPanel_content__3hbqG"};